import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavHomeInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || text_colorTextSecondary}
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m1.667 10.833 2.222-2.222m14.444 2.222-2.222-2.222m-12.222 0 5.404-5.404a1 1 0 0 1 1.414 0l5.404 5.404m-12.222 0V16.5a1 1 0 0 0 1 1h1.889a1 1 0 0 0 1-1v-3.444c0-1.228.995-2.223 2.222-2.223v0c1.227 0 2.222.995 2.222 2.223V16.5a1 1 0 0 0 1 1h1.89a1 1 0 0 0 1-1V8.611"
    />
  </svg>
)
export default SvgSidenavHomeInactive
